/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
// Added by Darragh C @ Shopify Theme Support August 15 2018

var sections = window.theme.sections;

var showLoadedVideo = {
  init: function() {

    // Assign 'variant_change' event handler
    this.on('slideshow_video_load', this._showVideoSlide.bind(this));
  },

  _showVideoSlide: function(event, instance, product, variant) {
    var self = this;
    setTimeout(function(){ 
      self.$slide.addClass('slideshow__video--loaded')
    }, 500)
  }

  
};

sections.extend('slideshow-section', showLoadedVideo);

// START: Essential Preorder App
document.addEventListener("DOMContentLoaded", () => {
  const purge = () => {
    let count = 0;
    const interval = setInterval(() => {
      count++;

      document.querySelectorAll(".cart-item__property").forEach((el) => {
        if (el.textContent.includes("_essential_preorder_campaign_id")) {
          el.style.display = "none";
        }
      });

      document.querySelectorAll(".cart-drawer__item-property").forEach((el) => {
        if (el.textContent.includes("_essential_preorder_campaign_id")) {
          el.style.display = "none";
        }
      });

      if (count >= 10) clearInterval(interval);
    }, 1);
  };

  purge();

  document.addEventListener("input", (e) => {
    if (e.target.matches('input[type="number"]')) purge();
  });

  const _fetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const res = await _fetch(...args);
    try {
      const url = typeof args[0] === "string" ? args[0] : (args[0]?.url || "");
      console.log('Working')
      if (url.includes("/cart")) purge();
    } catch {}
    return res;
  };
});
// END: Essential Preorder App


